export default __webpack_public_path__ + "addeaa1c30af65a3d53e7db86c29690e.svg";